import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'dls-inline-flex dls-items-center dls-rounded-xl dls-border dls-px-2.5 dls-py-0.5 dls-text-xs dls-font-semibold dls-transition-colors focus:dls-outline-none focus:dls-ring-2 focus:dls-ring-neutral focus:dls-ring-offset-2',
  {
    variants: {
      variant: {
        default: 'dls-border-transparent dls-bg-neutral-quarternary dls-text-foreground',
        secondary:
          'dls-border-transparent dls-bg-secondary dls-text-secondary-foreground hover:dls-bg-secondary/80',
        destructive:
          'dls-border-transparent dls-bg-destructive dls-text-destructive-foreground dls-shadow-10 hover:dls-bg-destructive/80',
        outline: 'dls-text-foreground',
        success: 'dls-border-transparent dls-bg-status-online-tertiary dls-text-neeve-primary',
        warning: 'dls-border-transparent dls-bg-status-warning-tertiary dls-text-status-warning',
        error: 'dls-border-transparent dls-bg-status-offline-tertiary dls-text-status-offline',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
